/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import GutenbergBlocks from "../components/gutenberg-blocks";
import PropTypes from "prop-types";
import SEO from "../components/seo";
import { gql } from "@apollo/client";

const SPECIAL_BLOCKS = [
  "core/cover",
  "mev/hero",
  "mev/superhero",
  "mev/calculator-big",
];

const Page = ({
  data: {
    wpPage: { editorBlocks, isFrontPage, title, seo },
  },
}) => {
  const HEADING_H1_BLOCK =
    editorBlocks?.[0]?.name === "core/heading" &&
    editorBlocks?.[0]?.attributes?.level === 1;

  return (
    <Layout>
      {/* {!isFrontPage && (
        <Container disableAnimation disableMargin>
          <Breadcrumbs breadcrumbList={seo?.breadcrumbs} />
          {!SPECIAL_BLOCKS.includes(editorBlocks?.[0]?.name) && !HEADING_H1_BLOCK && (
            <>
              <h1 style={{ textAlign: "center" }}>{title}</h1>
              <Separator className="is-style-default" color="primary" />
            </>
          )}
        </Container>
      )} */}
      <GutenbergBlocks blocks={editorBlocks} isTopLevel={true} />
    </Layout>
  );
};

Page.propTypes = {
  data: PropTypes.object,
};

export default Page;

export const Head = ({
  data: {
    wpPage: { excerpt, title, seo },
  },
  location,
}) => (
  <SEO
    title={seo?.title || title}
    description={seo?.metaDesc || excerpt}
    breadcrumbs={seo?.breadcrumbs}
    url={location.pathname}
  />
);

export const query = graphql`
  query ($id: String!) {
    wpPage(id: { eq: $id }) {
      editorBlocks {
        ...GutenbergBlocks
      }
      title
      excerpt
      uri
      isFrontPage
      seo {
        title
        breadcrumbs {
          text
          url
        }
        metaDesc
      }
    }
  }
`;

Page.privateQuery = gql`
  ${GutenbergBlocks.privateQuery}
  query PageTemplate($uri: String!) {
    wpPage: pageBy(uri: $uri) {
      editorBlocks {
        ...GutenbergBlocks
      }
      title
      excerpt
      uri
      id
    }
  }
`;
